/**
 * Inline MSW responses for the Saved Views API. Saved views are created at
 * runtime (no exported production fixture), so a representative inline set lets
 * the index page, nav, and snapshots render real data in mock mode. The live
 * backend serves the real data when Mock Data is toggled off.
 */
export const SAVED_VIEWS_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  "/apollo/saved-views/get-all-views": [
    {
      savedViewId: "00000000-5678-0000-0000-000000000001",
      viewType: "company",
      name: "At-Risk Call List",
      description: "Daily & weekly shippers at risk of churn",
      ownerEmail: "demo@freightsimple.com",
      isOwner: true,
      isFollowing: false,
      followers: ["chris@freightsimple.com"],
      createdAt: "2026-06-01T10:00:00Z",
    },
    {
      savedViewId: "00000000-5678-0000-0000-000000000002",
      viewType: "company",
      name: "New Toronto Leads",
      description: undefined,
      ownerEmail: "chris@freightsimple.com",
      isOwner: false,
      isFollowing: true,
      followers: [
        "demo@freightsimple.com",
        "edgardo.valencia@freightsimple.com",
      ],
      createdAt: "2026-05-20T09:00:00Z",
    },
    {
      savedViewId: "00000000-5678-0000-0000-000000000003",
      viewType: "shipment",
      name: "Overdue Pickups",
      description: "Booked but not yet picked up",
      ownerEmail: "edgardo.valencia@freightsimple.com",
      isOwner: false,
      isFollowing: false,
      followers: [],
      createdAt: "2026-05-15T14:30:00Z",
    },
  ],
  "/apollo/saved-views/get-view-detail": {
    savedViewId: "00000000-5678-0000-0000-000000000001",
    viewType: "company",
    name: "At-Risk Call List",
    description: "Daily & weekly shippers at risk of churn",
    ownerEmail: "demo@freightsimple.com",
    isOwner: true,
    isFollowing: false,
    followers: ["chris@freightsimple.com"],
    columnConfig: "{}",
    filters: "{}",
    createdAt: "2026-06-01T10:00:00Z",
  },
  // Create / duplicate return the new id; the rest are void-ish POSTs.
  "/apollo/saved-views/create-view": {
    savedViewId: "00000000-5678-0000-0000-000000000099",
  },
  "/apollo/saved-views/duplicate-view": {
    savedViewId: "00000000-5678-0000-0000-000000000098",
  },
  "/apollo/saved-views/update-view": {},
  "/apollo/saved-views/edit-view": {},
  "/apollo/saved-views/delete-view": {},
  "/apollo/saved-views/follow-view": {},
  "/apollo/saved-views/unfollow-view": {},
};
